import React, {useEffect} from 'react';
import {
    checkPageNameExists,
    checkHasSpaces,
    checkIfEmpty
} from '../../../validations/validations'
import PopUpValidationCore from './PopUpValidationCore';
import { returnNewPageName } from './ClickedNewPagePopUp';
import { convertBodyToHtmlCode } from '../GrapesJs/LoadCommands/ExportCode';

const ClickedDuplicatePagePopUp = (props) => {

    const{
        openDuplicatePage,
        setOpenDuplicatePage,
        selectedProject,
        selectedPage,
        newPageClicked,
        editor
    }=props;

    
    const [pageName, setPageName] = React.useState('');

    useEffect( () => {
        if(openDuplicatePage === true){
            const newPageName = returnNewPageName();
            setPageName(newPageName);
        } 
    },[openDuplicatePage])

    const handleCancel = () => {
        setOpenDuplicatePage(false);
    }

    const handlePageName = (val) => {
        setPageName(val.target.value);
    }

    const updateAttributes = () =>{

        if( checkIfEmpty(pageName) === false && checkHasSpaces(pageName) === false && checkPageNameExists(pageName, selectedProject,100) === false ){
            const isEdit = true;     
            const tempData = JSON.parse(localStorage.getItem('data'))[selectedProject].pages[selectedPage];
            if ('pageId' in tempData) delete tempData.pageId;
            if ('__v' in tempData)  delete tempData.__v;
            tempData.name = pageName;
            tempData.projectId = JSON.parse(localStorage.getItem('data'))[selectedProject]._id;
            tempData.html = convertBodyToHtmlCode(editor.getHtml(),pageName);
            newPageClicked(pageName,isEdit, tempData);
            setOpenDuplicatePage(false);   
        }
    }

    return(
            <PopUpValidationCore
                title='Duplicate page'
                page_description='New page name'
                open={openDuplicatePage}
                setOpen={setOpenDuplicatePage}
                handlePageName={handlePageName}
                pageName={pageName}
                selectedProject={selectedProject}
                handleCancel={handleCancel}
                updateAttributes={updateAttributes}
                selectedPage={100}
                cause='DuplicatePage'
            />
    )

}

export default ClickedDuplicatePagePopUp;